class Global {
  
  isEmpty(data,exclude_index) {
  	if(!exclude_index){
  		exclude_index = [];
  	}
    // check data is required
    for(var index in data){
      if(!exclude_index.includes(index)){
        if(Array.isArray(data[index]) || data[index] instanceof Object){
          var once = false;
          for(var child in data[index]){
            if(data[index][child]["value"]){
              once = true;
              break;
            }
          }

          if(once == false){
            return true;
            break;
          }
        }
        else if(!data[index]){
          return true;
          break;
        }
      }
    }
    return false;
  }

  addCommas(nStr){
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + ((x[1] && x[1].length>1)?x[1]:x[1]+"0") : '.00';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }
}

export default new Global();